import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

type Props = {
  missingPermission?: string;
};

export const NoPermissions = observer(({ missingPermission }: Props) => {
  const { t } = useTranslation();
  return (
    <div className='no-permissions-page'>
      <div className='row'>
        <div className='col-12'>
          <div className='wrapper no-permissions'>
            <div className='row flex-column-reverse flex-md-row'>
              <div className='col-md-6 col-sm-12'>
                <div className='welcome-text'>
                  <p>{t('noPermissions.Title')}</p>
                </div>
                <p>{t('noPermissions.Text', { permission: missingPermission })}</p>
              </div>
              <div className='col-md-6 col-sm-12'>
                <img className='no-permissions-img' src='/assets/img/imac-ipad@3x.png' alt='' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default NoPermissions;
